import gql from "graphql-tag";

export default gql`
  fragment signatureInfo on File {
    id
    url
  }
`;
